// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"markdown_scroll-black__OlApF","description":"markdown_description__NKxAq","standart":"markdown_standart__wXtzK"};